/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvalidateAllRefreshTokensRequest } from '../../models/invalidate-all-refresh-tokens-request';

export interface InvalidateAllRefreshTokens$Params {
      body: InvalidateAllRefreshTokensRequest
}

export function invalidateAllRefreshTokens(http: HttpClient, rootUrl: string, params: InvalidateAllRefreshTokens$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, invalidateAllRefreshTokens.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

invalidateAllRefreshTokens.PATH = '/management/v0/auth/refresh-tokens/invalidate-all';
